import apiClient from '../middleware/apiClient';
import { INTERNET_TIER } from '../helpers/apis';
import { COTTON_INTERNET_TIER } from '../helpers/cottonApis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';

export const GET_INTERNET_TIER = 'GET_INTERNET_TIER';
export const GET_INTERNET_TIER_SUCCESS = 'GET_INTERNET_TIER_SUCCESS';
export const GET_INTERNET_TIER_FAILURE = 'GET_INTERNET_TIER_FAILURE';

function dispatchGetInternetTier(isCottonSession = false) {
  const endpoint = isCottonSession ? COTTON_INTERNET_TIER : INTERNET_TIER;
  return {
    type: GET_INTERNET_TIER,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetInternetTierSuccess(tierData) {
  return {
    type: GET_INTERNET_TIER_SUCCESS,
    payload: tierData,
  };
}

function dispatchGetInternetTierFailure(error) {
  return {
    type: GET_INTERNET_TIER_FAILURE,
    payload: error,
  };
}

export const getInternetTier = () => async (dispatch, getState) => {
  if (getState().internetTier.cached) {
    return null;
  }

  try {
    const isCottonSession = getCottonSession();
    const response = await dispatch(dispatchGetInternetTier(isCottonSession)).payload;
    return dispatch(dispatchGetInternetTierSuccess(response));
  } catch (error) {
    dispatch(dispatchGetInternetTierFailure(error));
    throw error;
  }
};
